import { Component, type ReactNode } from 'react';

/**
 * A boundary for decoration: when what it wraps throws, it shows `fallback`
 * (nothing by default) and the screen goes on. First-impressions design §7 —
 * a face is never worth a broken form. `AidsPanel`'s `TranslationBoundary` is
 * the same shape with an error message, for a section the learner asked for.
 */
export class QuietBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children;
  }
}
